<template>
    <div>
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol sm="1" col="2">
              <img src="/img/icon/store.png" style="width: 32px; height:32px;" />
            </CCol>
            <CCol sm="9" col="7">
              <select class="custom-select text-dark" v-model="shopObjectId" disabled>
                <option selected>{{ $t('selectshop') }}</option>
                <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                  {{ shop.shopName }} - {{ shop.branchName }}
                </option>
              </select>
  
            </CCol>
            <div class="col-md-2 col-sm-2 col-3 text-right" v-if="loadingButton == true">
              <CButton block color="light" @click="goback()">
                <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{ $t('back')}}
              </CButton>
            </div>
            <div class="col-md-2 col-sm-2 col-3 text-right" v-else>
              <CButton block color="success" disabled>
                <CSpinner color="white" size="sm" />{{ $t('loading') }}
              </CButton>
            </div>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol class="col-md-10 col-sm-9 col-8 ">
              <h4 class="mb-3">{{$t('addProductPackage')}}</h4>
            </CCol>
            <CCol class="col-md-2 col-sm-3 col-4 text-right">
              <CButton :disabled="loading || !packageName.trim() || !selectedItems.length" @click="addPackage"
                class="btn btn-success" block>
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{$t('saveProductPackage')}}
              </CButton>
            </CCol>
          </CRow>
          <CAlert color="info" class="d-inline-block col-12 mt-1 mb-3">
            <div class="d-flex p-1">
              <div class="flex-shrink-0">
                <i class="fi fi-rr-info mr-1 text-info"></i>
              </div>
              <div class="flex-grow-1 ms-3 ml-2">
                <p class="m-0 font-weight-bold">{{$t('addPackageDes')}}</p>
                <p class="m-0 text-description text-muted">{{ $t('addPackageDes1') }}</p>
              </div>
            </div>
          </CAlert>
          <div class="mb-3">
            <h5 for="packageName" class="h5 mb-0"><b class="text-danger">*</b> {{$t('packageName')}}</h5>
            <!-- //คำอธิบาย 1 แพ็ตเกต / 1 bill ราคาเด็ก /ผู้ใหญ่ เป็น SKU  -->
            <small class="text-description text-muted">
              {{ $t('addPackageDes2') }}
            </small>
            <small class="text-muted d-block mb-2">
              {{ $t('addPackageDes3') }}
            </small>
            <input v-model="packageName" type="text" class="form-control" id="packageName"
               :placeholder="$t('addPackageDes4')" />
          </div>
          <div class="mb-3">
            <h5 for="packageDescription" class="form-label mb-0">{{$t('packageDes')}}</h5>
            <small class="text-description text-muted">
              {{ $t('packageDes1') }}
            </small>
            <textarea v-model="packageDescription" class="form-control" id="packageDescription" rows="3"
            :placeholder="$t('packageDes')"></textarea>
          </div>
  
          <h5 class="mb-0">
            {{ $t('packageImg') }}
          </h5>
          <small class="text-description text-muted">
            {{ $t('packageImgDes') }}
          </small>
          <div class="img-inputbox mt-2 position-relative mb-4" :class="{ 'dragover': isDragging }"
            @click="triggerFileInput" @dragover.prevent="isDragging = true" @dragleave="isDragging = false"
            @drop="handleDropAndReset">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <template v-if="remoteImagePath">
                <img :src="remoteImagePath" style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;" />
                <CButton @click.stop="removeImage" color="danger" size="sm" class="position-absolute"
                  style="top: 4px; right: 4px; z-index: 10; line-height: 1;">
                  <i class="fi fi-rr-trash"></i>
                </CButton>
              </template>
              <template v-else>
                <div class="pt-1 text-center text-muted">
                  <i class="fi fi-rr-plus-small h1 p-0"></i>
                  <div class="small">{{ $t('draImgHere') }}</div>
                </div>
              </template>
              <input ref="input_img" style="visibility: hidden; display: none;" type="file" accept="image/*"
                @change="handleFileSelect" />
            </div>
          </div>
  
          <!-- <hr /> -->
          <div>
            <CRow class="mb-2">
              <CCol class="text-left col-md-10 col-sm-9 col-8">
                <h5 class="mb-0"><b class="text-danger">*</b> {{$t('productInPackage')}} 
                  <span class="text-muted"
                    v-if="selectedItems.length > 0">({{ productTotal }}
                    {{$t('items')}}  {{ categoryTotal }} {{$t('category')}})</span> </h5>
                <small class="text-description text-muted">
                    {{$t('selectProductToAddPackageDes')}}
                </small> 
              </CCol>
              <CCol class="text-right" sm="3" md="2" col="4">
                <CButton color="primary" block @click="addProductModal = true">
                  {{$t('addProduct')}}
                </CButton>
              </CCol>
            </CRow>
            <div
              style="max-height: 60vh; overflow-y: auto;border-radius: 5px; border: 2px dashed #cfcfcf; min-height: 50vh; "
              class="p-4">
              <div v-if="selectedProductsByCategory.length === 0"
                class="d-flex flex-column justify-content-center align-items-center text-center" style="min-height: 46vh;"
                @click="addProductModal = true">
                <i class="fi fi-rr-box-open mb-1" style="font-size: 3rem; color: #ccc;"></i>
                <p class="mb-1 font-weight-bold"> {{$t('packagehavenotproduct')}}</p>
                <small class="text-muted"> {{$t('click')}} <strong>{{$t('addProduct')}}</strong> {{$t('cilckToSelect')}}</small>
              </div>
              <VueDraggable v-else :list="selectedProductsByCategory"
                :options="{ animation: 200, handle: '.category-handle', group: 'categories' }" @end="updateCategoryOrder">
                <div v-for="(group, groupIndex) in selectedProductsByCategory" :key="group.category + '-' + groupIndex"
                  class="mb-3">
                  <div
                    class="d-flex justify-content-between align-items-center bg-light p-2 fw-bold border-bottom rounded category-handle"
                    style="cursor: grab;">
                    <strong><span class="mr-2">
                        <CIcon name="cil-menu"
                          v-c-tooltip="{ content: $t('dragToChangeOrder'), placement: 'buttom' }" />
                      </span> {{ group.category }} ({{ group.products.length || 0 }} {{$t('items')}}) </strong>
                    <span>
                      <CButton color="danger" size="sm" @click.stop="removeCategory(group.category)"
                        style="line-height: 1;    padding: 0.1rem 0.1rem">
                        <CIcon name="cil-x" />
                      </CButton>
                    </span>
                  </div>
  
                  <!-- Product drag zone -->
                  <VueDraggable :list="group.products" :options="{
                    animation: 150,
                    group: 'products-in-' + group.category, // ไม่ให้ข้ามกลุ่ม
                    handle: '.product-handle'
                  }" @end="() => updateProductOrder(group)" class="row pt-0 pr-1 pl-1">
                    <!-- <div > -->
                    <div v-for="product in group.products" :key="product.objectId" class="col-12 col-md-4 ml-0 mr-0 p-1">
                      <div class="list-group-item d-flex align-items-center border rounded p-2 product-handle">
                        <div class="me-3 mr-3" style="width: 50px; aspect-ratio: 4 / 3;">
                          <img v-if="product.remoteImagePath" :src="product.remoteImagePath"
                            style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px" />
                          <div v-else style="width: 100%; height: 100%; border-radius: 4px"
                            :style="{ backgroundColor: util.generateColor(product.indexColor) }"></div>
                        </div>
                        <div>
                          <!-- ใช้เฉพาะตรงนี้เป็นจุดลาก -->
                          <div class="fw-bold product-handle" style="cursor: grab;">
                            {{ product.SKUName }}
                          </div>
                          <div class="text-muted small">
                            {{$t('pricePackage')}}: {{ product.ProductPRU.exceedUc }}
                          </div>
                        </div>
                        <CButton color="light" size="sm" class="ml-auto"
                          @click.stop="removeProductFromGroup(group.category, product.objectId)"
                          style="line-height: 1; padding: 0.1rem 0.1rem"
                          v-c-tooltip="{  content:$t('dragToSelectProduct'), placement: 'left' }">
                          <CIcon name="cil-x" />
                        </CButton>
                      </div>
                    </div>
                    <!-- </div> -->
                  </VueDraggable>
                </div>
              </VueDraggable>
            </div>
          </div>
        </CCardBody>
      </CCard>
  
      <modal :show.sync="addProductModal" size="xl" :footer="false">
        <template>
          <div>
            <!-- Top Header -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5>{{$t('selectdProduct')}}</h5>
            </div>
            <CRow>
              <CCol lg="3" col="5">
                <multiselect v-model="searchCategory" :options="dataCategory" :search="true" :showLabels="false"
                  :close-on-select="true" :clear-on-select="false" :placeholder="$t('selectCategoryInput')" label="name"
                  track-by="name" @input="setSearch" class="text-dark font-weight-normal  align-items-center" 
                  style=" 
                      -webkit-box-align: center !important;
                      -ms-flex-align: center !important;
                      align-items: center !important;">
                </multiselect>
              </CCol>
              <CCol lg="7" col="5">
                <input v-model="searchTerm" class="form-control" type="text" placeholder="Search product" />
              </CCol>
              <CCol lg="2" col="2">
                <CButton color="primary" block>
                  {{$t('search')}}
                </CButton>
              </CCol>
            </CRow>
  
            <!-- Product by Category -->
            <!-- Global Select All -->
            <CRow class="mb-1 mt-3">
              <CCol>
                <div class="text-left ">
                  <div class="custom-checkbox-wrapper">
                    <input type="checkbox" id="selectAllGlobal" :checked="areAllSelected" @change="toggleSelectAll"
                      class="custom-checkbox-input" />
                    <label for="selectAllGlobal" class="ml-2 mb-0">{{$t('selectAllProduct')}}</label>
                  </div>
                </div>
              </CCol>
              <CCol class="text-right">
                <span class="text-muted" v-if="selectedItems.length > 0">{{$t('select')}} {{ productTotal }} {{$t('items')}} {{
                  categoryTotal }} {{$t('category')}}</span>
              </CCol>
            </CRow>
            <div style="max-height: 60vh; overflow-y: auto; ">
              <div v-for="(products, category) in filteredCategorizedProducts" :key="category" class="mb-2"
                style="border: 1px solid #ddd; border-radius: 8px;">
                <!-- Category Header -->
                <div class="d-flex justify-content-between align-items-center bg-light p-2 fw-bold border-bottom"
                  style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1;">
                  <span>
                    <div class="custom-checkbox-wrapper d-flex align-items-center">
                      <input type="checkbox" :id="'selectAll-' + category" :checked="areAllSelectedByCategory(category)"
                        @change="toggleSelectAllByCategory(category)" class="custom-checkbox-input" />
                      <label :for="'selectAll-' + category" class="mb-0 ms-2"> {{ category }} (สินค้า {{ products.length }} รายการ)</label>
                    </div>
                  </span>
                  <!-- <span>{{ category }} (สินค้า {{ products.length }} รายการ)</span> -->
                </div>
                <!-- Product Items -->
                <div v-for="(product, index) in products" :key="product.objectId" :class="[
                  'd-flex align-items-center justify-content-between p-2 pb-0',
                  { 'border-bottom': index !== products.length - 1 }
                ]" @click="toggleItem(product.objectId)" style="cursor: pointer;">
                  <div class="d-flex align-items-center">
                    <input type="checkbox" :id="'checkbox-' + product.objectId" :value="product.objectId"
                      v-model="selectedItems" class="custom-checkbox-input me-2 mr-3" />
                    <label :for="'checkbox-' + product.objectId" class="d-flex align-items-center mb-0">
                      <div class="me-2 mr-3" style="width: 50px; height: auto; aspect-ratio: 4 / 3;">
                        <img v-if="product.remoteImagePath" :src="product.remoteImagePath" alt="product"
                          style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px" />
                        <div v-else style="width: 100%; height: 100%; border-radius: 4px"
                          :style="{ backgroundColor: util.generateColor(product.indexColor) }"></div>
                      </div>
                      <div>
                        <div>{{ product.SKUName }}</div>
                      </div>
                    </label>
                  </div>
  
                  <!-- ✅ เพิ่มราคาสินค้า -->
                  <div class="text-end text-muted small">
                    {{$t('pricePackage')}} : {{ product.ProductPRU.exceedUc || 0.00 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </modal>
      <CRow>
        <CModal :closeOnBackdrop="false" color="success" :show.sync="selectimg" :title="$t('selectImg')" centered>
          <div class="text-center" v-if="loadingSaveimg">
            <CRow id="colorButtons" class="justify-content-center align-items-center m-0">
              <CCol v-for="item in colorList" :key="item.value" class="color-picker-col">
                <CButton :class="['color-picker-btn', { active: indexColor === item.value }]"
                  :style="{ backgroundColor: item.color }" @click="setindexcolor(item.value)">
                  <i v-if="indexColor === item.value" class="fi fi-rr-check selected-icon"></i>
                </CButton>
              </CCol>
            </CRow>
            <hr />
            <div class="row">
              <div :class="imageDataBtn.length > 0 ? 'col-md-9 col-6 text-left' : 'col-md-12 col-12 text-left'">
                <div class="file-upload-container  pr-4 pl-5 pt-0 mb-1">
                  <label class="custom-file-label ml-2">
                    <input type="file" ref="fileInput" accept="image/*" @click="triggerFileInput" />
                    <i class="fa fa-upload"></i> {{ $t('selectImgFromPC') }}
                  </label>
                </div>
              </div>
              <div v-if="imageDataBtn.length > 0" class="col-md-3 col-6 text-right" id="deleteImageSection">
                <CButton style="color: red" @click="removeImage" id="deleteImageButton">
                  <i class="fi fi-rr-trash"></i> {{ $t("deleteImg") }}
                </CButton>
              </div>
              <div v-if="imageDataBtn.length > 0" class="col-md-12 text-center  mt-2">
                <div class="drop-area" :class="{ dragover: isDragging }" @dragover.prevent="isDragging = true"
                  @dragleave="isDragging = false" @drop="handleDropInModal">
                  <VueCropper v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')" :key="cropperKey"
                    v-show="imageDataBtn" :guides="true" :aspectRatio="selectedRatio" :initialAspectRatio="selectedRatio"
                    ref="cropper" :src="imageDataBtn" alt="Source Image" :zoomable="false" :scalable="false"
                    :style="{ height: cropperHeight + 'px' }">
                  </VueCropper>
                  <img v-else :src="imageDataBtn" class="img-fluid" :style="{ height: cropperHeight + 'px' }" />
                </div>
              </div>
              <div class="text-center p-3" v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')">
                <div class="row align-items-center d-flex">
                  <div class="col-auto flex-grow-1 d-flex justify-content-center" v-for="(ratio, index) in cropRatios"
                    :key="index" style="padding-left: 1px; padding-right: 1px;">
                    <CButton color="dark" class="ratio-btn w-100 text-center"
                      :class="{ active: selectedRatio === ratio.value }" @click="setCropRatio(ratio.value)">
                      <p class="mb-0 ml-1 mr-1">{{ ratio.label }}</p>
                    </CButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center" width="100%">
              <button class="btn" type="button" disabled style="color: darkcyan">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t('imageUploading') }}...
              </button>
            </div>
          </div>
          <template #footer-wrapper>
            <CRow class="pl-4 pr-4 pb-4">
              <CCol>
                <CButton block color="light" @click="cancel">
                  {{ $t('cancel') }}
                </CButton>
              </CCol>
              <CCol>
                <CButton block color="success" v-if="loadingSaveimg" @click="savecolorimg">
                  {{ $t('save') }}
                </CButton>
                <CButton block color="success" v-else disabled>
                  {{ $t('save') }}
                </CButton>
              </CCol>
            </CRow>
          </template>
        </CModal>
      </CRow>
    </div>
  </template>
  
  <script>
  import pos from "@/services/local";
  import util from "@/util/util";
  import Multiselect from "vue-multiselect";
  import { mapGetters } from 'vuex'
  import VueCropper from 'vue-cropperjs'
  import 'cropperjs/dist/cropper.css'
  import mime from '@/util/mime'
  import { VueDraggable } from 'vue-draggable-plus'
  import { CButton } from "@coreui/vue";
  
  export default {
    data() {
      return {
        util,
        searchTerm: '',
        packageName: '',
        packageDescription: '',
        selectedItems: [],
        loading: false,
        products: [],
        keyword: this.$route.query.keyword || "",
        searchBy: this.$route.query.searchBy || "",
        sort_value: {
          name: "SKUName",
          updated_at: "updated_at",
          category: "category.name",
          sortByNumMin: "sortByNumMin",
          sortByNumMax: "sortByNumMax",
        },
        sortdata: this.$route.query.sort || "category.name",
        meta_data: {
          last_page: null,
          current_page: 1,
          prev_page_url: null,
          items: 0,
          limit: 100,
          itemCount: 0,
        },
        addProductModal: false,
        dataCategory: [],
        searchCategory: "",
        shop: this.$store.getters.shopObjectId,
        selectimg: false,
        imageDataBtn: '',
        isUpload: false,
        cropperKey: 0,
        selectedRatio: 1,
        loadingSaveimg: true,
        isload: false,
        genObjectId: '',
        remoteImagePath: '',
        indexColor: 1,
        colori: util.generateColor(1),
        isDragging: false,
        selectedProductsByCategory: []
  
      };
    },
    created() {
      this.getProduct();
      this.getCategory()
      this.generateObjectId()
    },
    computed: {
      ...mapGetters(['shops', 'users', 'date']),
      cropperHeight() {
        if (window.innerWidth < 480) return 200;
        if (window.innerWidth < 768) return 250;
        return 300; // ค่าเริ่มต้นสำหรับหน้าจอใหญ่
      },
      colorList() {
        let data = [];
        for (let i = 0; i < 30; i++) {
          data.push({
            color: util.generateColor(i),
            value: i,
          });
        }
        return data;
      },
      cropRatios() {
        return [
          { label: "Freeform", value: "freeform" },
          { label: "1:1", value: "1:1" },
          { label: "3:2", value: "3:2" },
          { label: "4:3", value: "4:3" },
          { label: "16:9", value: "16:9" },
          { label: "Original Ratio", value: "original" }
        ]
      },
      contentMinH() {
        return `calc(100vh - 400px)`;
      },
      productTotal() {
        return this.selectedItems.length;
      },
      noImage() {
        return process.env.VUE_APP_NOIMAGE
      },
      categoryTotal() {
        return Object.keys(this.selectedProductsByCategory).length;
      },
      selectedItemsDetail() {
        return this.products.filter((p) => this.selectedItems.includes(p.objectId));
      },
      // selectedProductsByCategory() {
      //   const grouped = {};
  
      //   const categoryMap = {};
      //   this.dataCategory.forEach((cat) => {
      //     categoryMap[cat.objectId] = cat;
      //   });
  
      //   this.products.forEach(product => {
      //     if (this.selectedItems.includes(product.objectId)) {
      //       const categoryId = product.category?.objectId;
      //       const category = categoryMap[categoryId] || { name: 'ไม่ระบุหมวด', objectId: 'unknown' };
      //       const key = category.name;
  
      //       if (!grouped[key]) grouped[key] = { category: key, products: [] };
      //       grouped[key].products.push(product);
      //     }
      //   });
  
      //   return Object.values(grouped); 
      // },
      categorizedProducts() {
        const grouped = {};
  
        // Map category.objectId => category object
        const categoryMap = {};
        this.dataCategory.forEach((cat) => {
          categoryMap[cat.objectId] = cat;
        });
  
        this.products.forEach((product) => {
          const categoryId = product.category?.objectId;
          const category = categoryMap[categoryId] || { name: 'ไม่ระบุหมวด', objectId: 'unknown' };
          const key = category.name;
  
          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(product);
        });
  
        return grouped;
      },
      filteredCategorizedProducts() {
        const filtered = {};
        const term = (this.searchTerm || '').toLowerCase();
  
        Object.entries(this.categorizedProducts).forEach(([cat, products]) => {
          const matches = products.filter((p) =>
            (p.SKUName || '').toLowerCase().includes(term) ||
            (p.objectId || '').toLowerCase().includes(term)
          );
          if (matches.length) filtered[cat] = matches;
        });
  
        return filtered;
      },
      areAllSelected() {
        const allIds = this.products.map((p) => p.objectId);
        return allIds.every((objectId) => this.selectedItems.includes(objectId));
      },
      shopObjectId: {
        get() {
          return this.$store.getters.shopObjectId;
        },
        set(newValue) {
          return this.$store.dispatch("setShop", newValue);
        },
      },
      sortedCategories() {
        return this.selectedProductsByCategory
          .slice()
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .map(group => ({
            ...group,
            products: group.products.slice().sort((a, b) => a.orderIndex - b.orderIndex),
          }));
      }
    },
    watch: {
      selectedItems: {
        immediate: true,
        handler() {
          const grouped = {};
  
          const categoryMap = {};
          this.dataCategory.forEach((cat) => {
            categoryMap[cat.objectId] = cat;
          });
  
          this.products.forEach(product => {
            if (this.selectedItems.includes(product.objectId)) {
              const categoryId = product.category?.objectId;
              const category = categoryMap[categoryId] || { name: 'ไม่ระบุหมวด', objectId: 'unknown' };
              const key = category.name;
  
              if (!grouped[key]) {
                grouped[key] = {
                  category: key,
                  products: [],
                  orderIndex: Object.keys(grouped).length
                };
              }
  
              grouped[key].products.push({
                ...product,
                orderIndex: grouped[key].products.length
              });
            }
          });
  
          // แปลงเป็น array เพื่อให้ draggable ใช้ได้
          this.selectedProductsByCategory = Object.values(grouped);
          console.log(this.selectedProductsByCategory);
          
        }
      }
    },
    components: {
      Multiselect,
      VueCropper,
      VueDraggable
    },
    methods: {
      ...util,
      removeCategory(categoryName) {
        const groupToRemove = this.selectedProductsByCategory.find(
          (group) => group.category === categoryName
        );
  
        if (groupToRemove) {
          const productIds = groupToRemove.products.map(p => p.objectId);
  
          // ลบสินค้าที่อยู่ใน selectedItems
          this.selectedItems = this.selectedItems.filter(
            (id) => !productIds.includes(id)
          );
  
          // ลบ group ออกจาก selectedProductsByCategory
          this.selectedProductsByCategory = this.selectedProductsByCategory.filter(
            (group) => group.category !== categoryName
          );
        }
      },
      removeProductFromGroup(categoryName, productId) {
        const group = this.selectedProductsByCategory.find(g => g.category === categoryName);
        if (group) {
          group.products = group.products.filter(p => p.objectId !== productId);
          if (group.products.length === 0) {
            this.removeCategory(categoryName);
          }
          this.selectedItems = this.selectedItems.filter(id => id !== productId);
        }
      },
      updateCategoryOrder() {
        this.selectedProductsByCategory.forEach((group, index) => {
          group.orderIndex = index;
        });
      },
      updateProductOrder(group) {
        group.products.forEach((product, index) => {
          product.orderIndex = index;
        });
      },
      setCropRatio(value) {
        if (value === "freeform") {
          this.selectedRatio = NaN; // อัตราส่วนอิสระ
        } else if (value === "original") {
          const imageData = this.$refs.cropper.getImageData()
  
          this.selectedRatio = imageData.naturalWidth / imageData.naturalHeight; // คงอัตราส่วนเดิม
        } else {
          const [w, h] = value.split(":").map(Number); // แปลงค่า "3:2" -> [3, 2]
          this.selectedRatio = w / h;
        }
        this.cropperKey++;
      },
      handleDropInModal(event) {
        this.handleDrop(event); // คุณมีอยู่แล้ว ใช้ซ้ำได้
        this.isDragging = false;
      },
      handleDropAndReset(event) {
        this.handleDrop(event)
        this.isDragging = false
      },
      setindexcolor(index) {
        this.indexColor = index;
        this.colori = util.generateColor(index);
        // this.imageDataBtn = "";
        this.selectcolor = false;
      },
      async removeImage() {
        this.imageData = "";
        this.imageDataBtn = "";
        this.remoteImagePath = "";
        this.isload = false;
        this.selectcolor = false;
      },
      generateObjectId() {
        const uid = `${localStorage.getItem('shopsUid')}`
        pos({
          method: 'get',
          url: '/api/v1.0/' + uid + '/objectId/generate',
        })
          .then((res) => {
            this.genObjectId = res.data.data.objectId
          })
          .catch((error) => {
            console.log(error)
          })
      },
      handleDrop(event) {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (!files || !files.length) return;
  
        const file = files[0];
        if (!file.type.startsWith("image/")) {
          alert("กรุณาเลือกรูปภาพเท่านั้น");
          return;
        }
  
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageDataBtn = e.target.result;
          this.isUpload = false;
          this.cropperKey++;
          this.selectimg = true;
        };
        reader.readAsDataURL(file);
      },
      async savecolorimg() {
        this.loadingSaveimg = false;
  
        try {
          if (this.$refs.cropper && this.$refs.cropper.getCroppedCanvas) {
            const croppedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
            this.imageData = croppedImage;
            this.imageDataBtn = croppedImage;
            await this.getImageURL();
          } else {
            this.imageData = '';
            this.remoteImagePath = '';
            this.selectimg = false;
          }
        } catch (error) {
          console.error('เกิดข้อผิดพลาดขณะบันทึกรูปภาพ:', error);
          this.$toast && this.$toast.error('บันทึกรูปภาพไม่สำเร็จ');
        } finally {
          this.loadingSaveimg = true;
        }
      },
      async resizeImage(base64Str, maxWidth = 650, maxHeight = 500) {
        return new Promise((resolve) => {
          let img = new Image()
          img.src = base64Str
          img.onload = () => {
            let canvas = document.createElement('canvas')
            const MAX_WIDTH = maxWidth
            const MAX_HEIGHT = maxHeight
            let width = img.width
            let height = img.height
  
            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            let ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)
            resolve(canvas.toDataURL())
          }
        })
      },
      async getImageURL() {
        let ref = this.genObjectId
  
        // if (this.$refs.cropper.getCroppedCanvas === undefined) {
        //   return
        // }
  
        const getCroppedCanvas = this.$refs.cropper.getCroppedCanvas().toDataURL()
        const resizedImage = await this.resizeImage(getCroppedCanvas)
        let ext = await mime.getExtension(resizedImage)
  
        if (ext == null) {
          alert('Only Support File Type Is JPEG, PNG')
          this.isload = false
        } else {
          const oldImagePath = this.imagePath
          // await uploadImage.deleteImage2(oldImagePath)
          const imageName = util.generateFilename('.' + ext)
          const ownerUID = `${localStorage.getItem('uid')}`
          const directoryPath = 'resources/' + ownerUID + '/resources/products/' + ref + '/' + imageName
  
          // this.remoteImagePath = await uploadImage.onUpload(ownerUID, ref, resizedImage, ext)
          let remoteImagePath = await this.onUploadProductImage(this.genObjectId, resizedImage);
          this.remoteImagePath = remoteImagePath
          this.imgTmpPath = remoteImagePath
          this.imagePath = directoryPath
          this.selectimg = false
          this.loadingSaveimg = true
        }
      },
      async onUploadProductImage(ref, image) {
        let headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) };
        let data = { ref, image };
        try {
          const res = await pos({
            method: 'POST',
            url: '/api/v3.0/upload/productimage',
            data,
            headers,
          });
          return res.data.data.publicUrl;
        } catch (error) {
          console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
          return '';
        }
      },
      getModalImg(item, index) {
        if (item.remoteImagePath && item.remoteImagePath !== '') {
          this.imageData = item.remoteImagePath;
          this.imageDataBtn = item.remoteImagePath;
          this.remoteImagePath = item.remoteImagePath;
          this.$refs.cropper = item.remoteImagePath;
          // ตรวจสอบว่า VueCropper โหลดหรือยัง ก่อนเรียก methods หรือ properties ใน ref
          this.$nextTick(() => {
            if (this.$refs.cropper) {
              this.$refs.cropper.replace(item.remoteImagePath); // อัปเดตรูปภาพที่จะแสดงใน cropper
            }
          });
        } else {
          this.remoteImagePath = '';
          this.imageData = '';
          this.imageDataBtn = '';
        }
        this.genObjectId = item.objectId
        this.indexColor = item.indexColor
        this.selectedIndex = index; // เก็บ index ของรายการที่เลือก
        this.selectimg = true
      },
      uploadImage(e) {
        const file = e.target.files[0]
  
        if (typeof FileReader === 'function') {
          this.dialog = true
  
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imageDataBtn = event.target.result
            this.$refs.cropper = this.imageData
            this.isUpload = false
            this.isload = true
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      cancel() {
        this.selectimg = false;
      },
      triggerFileInput() {
        this.$refs.input_img.click();
      },
      handleFileSelect(event) {
        const file = event.target.files[0];
        if (!file) return;
  
        // ตรวจสอบว่าเป็นรูป
        if (!file.type.startsWith('image/')) {
          alert('กรุณาเลือกรูปภาพ');
          return;
        }
  
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageDataBtn = e.target.result; // base64
          this.isUpload = false;
          this.cropperKey++; // force cropper re-render
          this.selectimg = true; // เปิด modal หลังโหลดเสร็จ
        };
        reader.readAsDataURL(file);
      },
      setSearch(searchBy, keyword) {
        this.keyword = keyword;
        this.searchBy = searchBy;
        this.getProduct();
      },
      toggleItem(objectId) {
        const index = this.selectedItems.indexOf(objectId);
        if (index === -1) {
          this.selectedItems.push(objectId);
        } else {
          this.selectedItems.splice(index, 1);
        }
      },
      toggleSelectAll() {
        if (this.areAllSelected) {
          this.selectedItems = [];
        } else {
          this.selectedItems = this.products.map((p) => p.objectId);
        }
      },
      saveSelection() {
        console.log("Selected:", this.selectedItems);
      },
      areAllSelectedByCategory(category) {
        const productIds = this.categorizedProducts[category].map((p) => p.objectId);
        return productIds.every((objectId) => this.selectedItems.includes(objectId));
      },
      toggleSelectAllByCategory(category) {
        const productIds = this.categorizedProducts[category].map((p) => p.objectId);
        const allSelected = this.areAllSelectedByCategory(category);
  
        if (allSelected) {
          // Unselect all
          this.selectedItems = this.selectedItems.filter(
            (objectId) => !productIds.includes(objectId)
          );
        } else {
          // Add missing ones
          this.selectedItems = Array.from(
            new Set([...this.selectedItems, ...productIds])
          );
        }
      },
      getProduct(page = this.$route.query.page || 1) {
        this.searchLoadingButton = false;
        this.loadingButton = false;
        const shopObjectId = this.shopObjectId;
        const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) };
  
        let sortOrder = "";
        if (this.sortdata == "sortByNumMin") {
          sortOrder = "asc";
        } else if (
          this.sortdata == "sortByNumMax" ||
          this.sortdata == "updated_at"
        ) {
          sortOrder = "desc";
        } else {
          sortOrder = "asc";
        }
  
        let params = {
          shopObjectId: shopObjectId,
          page: page,
          sortAttr: this.sortAttr,
          sortOrder: sortOrder,
          limit: this.meta_data.limit,
        };
        // Add search attribute.      
        if (this.searchCategory !== null) {
          // params["searchVal"] = this.keyword;
          params["categoryObjectId"] = this.searchCategory.objectId
        }
        pos({
          url: "/api/v3.0/productsku/quicklist",
          params: params,
          headers: headers,
          method: "GET",
        }).then((res) => {
  
          this.products = res.data.data.map((item) => ({
            ...item,
            edited: false, // รีเซ็ตสถานะการแก้ไข
          }));
  
  
          if (res.data.paginate.items == undefined) {
            this.countProduct = 0;
            this.meta_data.items = 0;
          } else {
            this.countProduct = res.data.paginate.items;
            this.meta_data.items = res.data.paginate.items;
          }
          this.meta_data.last_page = res.data.paginate.pageCount;
          this.meta_data.current_page = res.data.paginate.currentPage;
          this.meta_data.itemCount = res.data.paginate.itemCount;
          this.meta_data.limit = res.data.paginate.perPage;
          // this.countlist = res.data.data.length;
          this.searchLoadingButton = true;
          this.loadingButton = true;
        });
      },
      addPackage() {
  
      },
      getCategory() {
        const uid = `${localStorage.getItem("shopsUid")}`;
        const shopObjectId = this.shopObjectId;
        let params = {
          page: 1,
          limit: 1000,
        };
        const headers = {
          shopObjectId: util.sanitizeShopObjectId(shopObjectId),
        };
        pos
          .get("/api/v1.0/shop/" + uid + "/Category/data/" + shopObjectId, {
            params, headers
          })
          .then((res) => {
            this.dataCategory = res.data.data;
            let data = this.dataCategory;
            for (let i = 0; i < data.length; i++) {
              if (data[i].id == "0") {
                this.category = {
                  id: data[i].id,
                  name: data[i].name,
                  objectId: data[i].objectId,
                };
              }
            }
          });
      },
    },
  };
  
  </script>
  <style scoped>
  .img-inputbox {
    width: 200px;
    aspect-ratio: 4/3;
    border-radius: 4px;
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
  }
  
  .custom-checkbox-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  
  .custom-checkbox-input {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    cursor: pointer;
  }
  
  @media (max-height: 800px) {
    .category-scroll-box {
      max-height: 50vh;
    }
  }
  
  .drop-area {
    border: 2px dashed #ccc;
    border-radius: 10px;
    padding: 10px;
    transition: border 0.3s ease;
  }
  
  .drop-area.dragover {
    border-color: #29b289;
    background-color: #f9f9f9;
  }
  
  .display.dragover {
    border: 2px dashed #29b289;
    background-color: #f3fdfa;
    transition: 0.3s ease;
  }
  
  .dragover {
    border: 2px dashed #29b289;
    background-color: #e6f8f0;
    border-radius: 5px;
    transition: all 0.2s ease-in-out;
  }
  
  .custom-file-label i {
    font-size: 16px;
  }
  
  .color-picker-btn {
    /* width: 100%;
    height: 100%; */
    width: 26px;
    /* ปรับขนาดของปุ่ม */
    height: 26px;
    border-radius: 50%;
    /* ทำให้เป็นวงกลม */
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
  
  .color-picker-btn.active {
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
    /* ขอบเงา */
    position: relative;
  }
  
  .selected-icon {
    color: white;
    /* สีของไอคอนถูกเลือก */
    font-size: 14px;
  }
  
  /* Container สำหรับ Input File */
  .file-upload-container {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  
  /* ซ่อน input file */
  .file-upload-container input[type="file"] {
    display: none;
  }
  
  /* ปรับแต่งปุ่มอัปโหลด */
  .custom-file-label {
    /* padding: 10px 20px; */
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    /* ระยะห่างไอคอนกับข้อความ */
    transition: background-color 0.3s;
  }
  
  .custom-file-label:hover {
    /* background-color: #218838; */
  }
  
  /* ปรับขนาดไอคอน */
  .custom-file-label i {
    font-size: 16px;
  }
  
  .color-picker-col {
    width: 31px;
    /* ปรับขนาดของปุ่ม */
    height: 31px;
    display: contents;
    justify-content: center;
    align-items: center;
    padding: 2px;
  }
  
  .color-picker-btn {
    /* width: 100%;
    height: 100%; */
    width: 26px;
    /* ปรับขนาดของปุ่ม */
    height: 26px;
    border-radius: 50%;
    /* ทำให้เป็นวงกลม */
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
  
  .color-picker-btn.active {
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
    /* ขอบเงา */
    position: relative;
  }
  
  .selected-icon {
    color: white;
    /* สีของไอคอนถูกเลือก */
    font-size: 14px;
  }
  
  .img-inputbox.dragover {
    border: 2px dashed #29b289;
    background-color: #f3fdfa;
  }
  
  .drop-area.dragover {
    border: 2px dashed #29b289;
    background-color: #f3fdfa;
    transition: background-color 0.3s;
  }
  </style>
  <style src="../../../assets/styles/multiselect.css"></style>
  